import React from 'react';

import { Divider } from '@tmap/mmm-style-guide/src/Divider';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Drawer } from '@tmap/mmm-style-guide/src/Drawer';
import { IconButton } from '@tmap/mmm-style-guide/src/IconButton';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Close } from '@tmap/mmm-style-guide/src/Icon';

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (p) => p !== 'fullHeight',
})(({ fullHeight }) => ({
  maxHeight: '100%',
  display: 'flex',
  justifyContent: 'center',
  '& .MuiPaper-root': {
    width: '100%',
    maxWidth: '700px',
    borderTopRightRadius: '20px',
    borderTopLeftRadius: '20px',
    position: 'absolute',
    left: 'unset',
    right: 'unset',
    height: fullHeight ? '100%' : undefined,
  },
}));

const DrawerFooter = styled(Box)(({ theme }) => ({
  width: '100%',
  background: theme.palette.common.white,
  padding: theme.spacing(2),
  boxShadow: '0px 2px 10px -2px rgba(0, 0, 0, 0.18)',
}));
const DrawerBody = styled(Box, {
  shouldForwardProp: (p) => p !== 'fullHeight',
})(({ theme, fullHeight }) => ({
  paddingTop: theme.spacing(4.5),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3.5),
  paddingRight: theme.spacing(3.5),
  overflowY: 'scroll',
  height: fullHeight ? '100%' : undefined,
}));

export default function RoundedDrawer(props) {
  const {
    title,
    open,
    onClose,
    children,
    footer,
    fullHeight = false,
  } = props;
  return (
    <StyledDrawer anchor='bottom' open={open} onClose={onClose} fullHeight={fullHeight}>
      <Box display='flex' flexDirection='column' justifyContent='center' py={1.5} px={1}>
        <IconButton color='inverted' size='small' onClick={onClose} aria-label='close' sx={{ position: 'absolute' }}><Close /></IconButton>
        <Typography variant='h6' sx={{ textAlign: 'center' }} mx={4}>{title}</Typography>
      </Box>
      <Divider />
      <DrawerBody fullHeight={fullHeight}>
        {children}
      </DrawerBody>
      <DrawerFooter>
        {footer}
      </DrawerFooter>
    </StyledDrawer>
  );
}
